import axios from 'axios';
import * as Sentry from '@sentry/react';
import { getCustomModel } from './registry';
import { patchPathway } from './pathways';

const { get, post, patch } = axios;

// nodes
export const createNode = (pathwayId, data) => post(`/v1/pathways/${pathwayId}/nodes/`, data);
export const patchNode = (caseId, nodeId, data) => patch(`/v1/cases/${caseId}/nodes/${nodeId}/`, data);
export const renameNode = async (caseId, nodeId, name) => {
  const response = await patchNode(caseId, nodeId, { name });
  const node = response.data?.node ?? response.data;

  if (node?.internal_pathway_id) {
    try {
      await patchPathway(node.internal_pathway_id, { name: `${name} Internals` });
    } catch (error) {
      Sentry.captureException(error);
    }
  }

  return response;
};
export const getNode = (pathwayId, nodeId) => get(`/v1/pathways/${pathwayId}/nodes/${nodeId}/`);
export const removeNode = (pathwayId, nodeId) => axios.delete(`/v1/pathways/${pathwayId}/nodes/${nodeId}/`);
export const appendNodeIo = (pathwayId, nodeId, data) => post(`/v1/pathways/${pathwayId}/nodes/${nodeId}/ios/`, data);
export const deleteNodeIo = (pathwayId, nodeId, data) =>
  axios.delete(`/v1/pathways/${pathwayId}/nodes/${nodeId}/ios/`, { data });
export const getCaseNode = (caseId, nodeId) => get(`/v1/cases/${caseId}/nodes/${nodeId}/`);

export const getNodeParams = (caseId, nodeId) => get(`/v1/cases/${caseId}/nodes/${nodeId}/params/`);
export const patchNodeParams = (caseId, nodeId, data) => patch(`/v1/cases/${caseId}/nodes/${nodeId}/params/`, data);
export const putCaseNodeCustomProperties = (caseId, nodeId, data) =>
  axios.put(`/v1/cases/${caseId}/nodes/${nodeId}/custom_properties/`, data);

export const getNodeWithInfo = async (pathwayId, caseId, nodeId) => {
  let customModel;

  const [
    { data: node },
    { data: caseNode },
    {
      data: { params, is_default: isDefault },
    },
  ] = await Promise.all([getNode(pathwayId, nodeId), getCaseNode(caseId, nodeId), getNodeParams(caseId, nodeId)]);

  if (node.custom_id) {
    try {
      const { data } = await getCustomModel(node.custom_id);

      customModel = data;
    } catch {
      // Ignore error
    }
  }

  const { name } = caseNode;

  node.label = name || node.label;

  return { node, caseNode, customModel, params, isDefault };
};
export const getDerivedValue = (caseId, nodeId, paramName) =>
  get(`/v1/cases/${caseId}/nodes/${nodeId}/params/${paramName}/derived_value/`);

// param configurations
export const createParamConfiguration = data => post('/v1/param_configurations/', data);
export const updateParamConfiguration = (id, data) => patch(`/v1/param_configurations/${id}/`, data);
export const deleteParamConfiguration = (id, requestConfig = {}) =>
  axios.delete(`/v1/param_configurations/${id}/`, requestConfig);
